// extracted by mini-css-extract-plugin
export default {"gradientWrapper":"home_gradientWrapper__9qP+K","customDots":"home_customDots__b1TTk","slick-active":"home_slick-active__uDNQp","slick-dots":"home_slick-dots__6AaPI"};